import { render, staticRenderFns } from "./gallery_describe.vue?vue&type=template&id=b926069c&scoped=true&"
import script from "./gallery_describe.vue?vue&type=script&lang=js&"
export * from "./gallery_describe.vue?vue&type=script&lang=js&"
import style0 from "./gallery_describe.vue?vue&type=style&index=0&id=b926069c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b926069c",
  null
  
)

export default component.exports